import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-division-scholarships',
  templateUrl: './division-scholarships.component.html',
  styleUrls: ['./division-scholarships.component.scss']
})
export class DivisionScholarshipsComponent implements OnInit, OnDestroy {
  sports = [];
  commonServiceSub: Subscription;
  constructor(private _commonService: CommonService) { }

  ngOnInit() {
    this.commonServiceSub = this._commonService.getData().subscribe(detailData => {
      if (detailData && detailData['collegeDetailSocialCampusSports']) {
        this.sports = detailData['collegeDetailSocialCampusSports'].collegiate;
      }
     });
  }

  ngOnDestroy() {
    this.commonServiceSub.unsubscribe();
  }

}
